import axios from '../lib/axios';


// Type for Department (POST: only name and description required)
export interface Department {
  name: string;
  description: string;
  code?: string;
  manager?: string;
  location?: string;
  budget?: number;
  status?: 'active' | 'inactive';
  employeeCount?: number;
  projects?: number;
  [key: string]: any;
}

// Create a new department
export const createDepartment = async (data: Department) => {
  return axios.post('/departments', data);
};

// Get all departments
export const getDepartments = async () => {
  return axios.get('/departments');
};

// Get a department by ID
export const getDepartmentById = async (id: string | number) => {
  return axios.get(`/departments/${id}`);
};

// Update a department by ID
export const updateDepartment = async (id: string | number, data: Partial<Department>) => {
  return axios.patch(`/departments/${id}`, data);
};

// Delete a department by ID
export const deleteDepartment = async (id: string | number) => {
  return axios.delete(`/departments/${id}`);
}; 